import { render } from "./EmailValidation.vue?vue&type=template&id=5ed09a36"
import script from "./EmailValidation.vue?vue&type=script&lang=js"
export * from "./EmailValidation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__